import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';

import './Titularizare.css';

export default function Titularizare() {
    return (
        <Container className="titularizareContainer worldwide">
            <p className="titularizareTitle">
                <span className="bracket">{'<'}</span>
                    Titularizare
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="titularizareSubTitle">Află mai multe despre examenul de Titularizare</p>
            <Row>
                <p className="titularizareDescription">
                    Examenul de titularizare pentru Informatică și TIC în România este un concurs național organizat anual de
                    Ministerul Educației, destinat profesorilor care doresc să ocupe un post stabil (titular) în învățământul
                    preuniversitar.
                    <br/>
                    Proba scrisă evaluează atât cunoștințele de specialitate (programare, algoritmică, baze de date etc.), cât
                    și competențele didactice.
                    <br/>
                    Pentru titularizare, este necesară o notă de minimum 7.00 și existența unui post disponibil. Cu o notă peste
                    5.00, se poate obține un post pe perioadă determinată (suplinitor).
                </p>
                <p className="titularizareText1">Programa Examenului de Titularizare: <a href="/titularizare/19_Programa_titu_P_Informatica_si_tehnologia_informatiei.pdf" className="fixColor" target="blank">AICI</a></p>
                <Accordion alwaysOpen defaultActiveKey={['0']}>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <span># Subiecte (2015-Prezent)</span>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="table-responsive">
                                <Table striped bordered hover size="lg" className="table-dark text-center" style={{verticalAlign: "middle"}}>
                                    <thead style={{verticalAlign: "middle"}}>
                                        <tr>
                                            <th>Anul</th>
                                            <th>Subiect</th>
                                            <th>Barem</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>2026</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2026_var_01_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2026_bar_01_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2025</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2025_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2025_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2024</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2024_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2024_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2023</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2023_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2023_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2022</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2022_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2022_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2021</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2021_var_02_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2021_bar_02_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2020</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2020_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2020_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2019</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2019_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2019_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2018</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2018_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2018_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2017</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2017_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2017_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2016</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2016_var_01_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2016_bar_01_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                        <tr>
                                            <td>2015</td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2015_var_03_LRO.pdf" className="fixColor" target="blank">Subiect</a></td>
                                            <td><a href="/titularizare/Tit_050_Informatica_P_2015_bar_03_LRO.pdf" className="fixColor" target="blank">Barem</a></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
        </Container>
    )
}